import React, {useEffect, useState} from 'react';

function Top_Page(){

    const [effect, setEffect]= useState(false)

    useEffect(()=>{
        setEffect(true)
    }, [])
   
    return(
        <div className='title' className={`title ${effect?"title_effect":''}`}>
            <p className='top_page_title'>Art Museums </p>
            <p className='top_page_title'>in</p>
            <p className='top_page_title'>Berlin</p>
        </div>
    )
}
export default Top_Page;